const Colors = {
  transparent: 'transparent',
  white: '#fff',
  darken10: 'rgba(0, 0, 0, 0.1)',
  darken20: 'rgba(0, 0, 0, 0.2)',
  darken30: 'rgba(0, 0, 0, 0.3)',
  darken40: 'rgba(0, 0, 0, 0.4)',
  darken50: 'rgba(0, 0, 0, 0.5)',
  darken60: 'rgba(0, 0, 0, 0.6)',
  darken70: 'rgba(0, 0, 0, 0.7)',
  darken80: 'rgba(0, 0, 0, 0.8)',
  darken90: 'rgba(0, 0, 0, 0.9)',
  white03: 'rgba(255, 255, 255, 0.03)',
  white05: 'rgba(255, 255, 255, 0.05)',
  white08: 'rgba(255, 255, 255, 0.08)',
  white10: 'rgba(255, 255, 255, 0.1)',
  white12: 'rgba(255, 255, 255, 0.12)',
  white20: 'rgba(255, 255, 255, 0.2)',
  white30: 'rgba(255, 255, 255, 0.3)',
  white40: 'rgba(255, 255, 255, 0.4)',
  white50: 'rgba(255, 255, 255, 0.5)',
  white60: 'rgba(255, 255, 255, 0.6)',
  white70: 'rgba(255, 255, 255, 0.7)',
  white80: 'rgba(255, 255, 255, 0.8)',
  white90: 'rgba(255, 255, 255, 0.9)',
  black: '#030404',
  blue50: '#258FDA',
  blue100: '#2284c9',
  blue200: '#1f79b8',
  blue300: '#1c6ea8',
  blue400: '#1a6397',
  blue500: '#175886',
  blue600: '#144d75',
  blue700: '#114265',
  blue800: '#0e3754',
  blue900: '#0b2c43',
  blue950: '#061622',
  blue999: '#030b11',
  lightBlue50: '#eef6fc',
  lightBlue100: '#ddeef9',
  lightBlue200: '#cde5f6',
  lightBlue300: '#bcddf4',
  lightBlue400: '#abd4f1',
  lightBlue500: '#9acbee',
  lightBlue600: '#8ac3eb',
  lightBlue700: '#79bae8',
  lightBlue800: '#68b1e5',
  lightBlue900: '#57a9e3',
  desatBlue800: '#657f92',
  primeBlue50: '#5e8bff',
  primeBlue100: '#5984F2',
  primeBlue200: '#547de6',
  primeBlue300: '#4b6fcc',
  primeBlue400: '#4261b3',
  primeBlue500: '#385399',
  primeBlue600: '#2f4680',
  primeBlue700: '#263866',
  primeBlue800: '#1c2a4d',
  primeBlue900: '#131c33',
  red50: '#da2535',
  red100: '#c92231',
  red200: '#b81f2d',
  red300: '#971a25',
  red400: '#861721',
  red500: '#75141d',
  red600: '#651118',
  red700: '#540e14',
  red800: '#430b10',
  red900: '#32090c',
  lightRed50: '#fceeef',
  lightRed100: '#f9dde0',
  lightRed200: '#f6cdd0',
  lightRed300: '#f4bcc1',
  lightRed400: '#f1abb1',
  lightRed500: '#ee9aa2',
  lightRed600: '#eb8a92',
  lightRed700: '#e87983',
  lightRed800: '#e56873',
  lightRed900: '#e35764',
  lightRed950: '#e04754',
  lightRed999: '#dd3645',
  green50: '#22c967',
  green100: '#20b85f',
  green200: '#1da756',
  green300: '#1a974e',
  green400: '#178645',
  green500: '#14753c',
  green600: '#116534',
  green700: '#0e542b',
  green800: '#0c4323',
  green900: '#09321a',
  lightGreen50: '#eefcf4',
  lightGreen100: '#def9e9',
  lightGreen200: '#cdf6de',
  lightGreen300: '#bcf4d3',
  lightGreen400: '#abf1c8',
  lightGreen500: '#9beebd',
  lightGreen600: '#8aebb2',
  lightGreen700: '#79e8a7',
  lightGreen800: '#68e59c',
  lightGreen900: '#25da70',
  orange50: '#da6f25',
  orange100: '#c96722',
  orange200: '#b85e1f',
  orange300: '#a7551c',
  orange400: '#964d19',
  orange500: '#864417',
  orange600: '#753c14',
  orange700: '#643311',
  orange800: '#532b0e',
  orange900: '#42220b',
  lightOrange50: '#f9e8dd',
  lightOrange100: '#f6ddcc',
  lightOrange200: '#f4d2bb',
  lightOrange300: '#f1c7aa',
  lightOrange400: '#eebc9a',
  lightOrange500: '#ebb189',
  lightOrange600: '#e8a678',
  lightOrange700: '#e59b67',
  lightOrange800: '#e08546',
  lightOrange900: '#dd7a35',
  yellow50: '#f1ebaa',
  yellow100: '#eee79a',
  yellow200: '#ebe389',
  yellow300: '#e8df78',
  yellow400: '#e5db67',
  yellow500: '#e3d756',
  yellow600: '#e0d346',
  yellow700: '#ddcf35',
  yellow800: '#daca25',
  yellow900: '#c9bb22',
  grey50: '#6e7d84',
  grey100: '#65737a',
  grey200: '#5c696f',
  grey300: '#535f64',
  grey400: '#4b5559',
  grey500: '#424a4f',
  grey600: '#394044',
  grey700: '#303639',
  grey800: '#272c2f',
  grey900: '#1e2224',
  grey950: '#151819',
  grey999: '#0c0e0f',
  lightGrey50: '#f8f9f9',
  lightGrey100: '#eeeff0',
  lightGrey200: '#e3e6e8',
  lightGrey300: '#d8dcdf',
  lightGrey400: '#cdd3d6',
  lightGrey500: '#c3c9cd',
  lightGrey600: '#b8c0c4',
  lightGrey700: '#adb6bb',
  lightGrey800: '#a3adb2',
  lightGrey900: '#98a3a9',
  lightGrey950: '#8d9aa1',
  lightGrey999: '#77878f',
};

export default Colors;
